import { Component, OnInit } from '@angular/core';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { ServiceCatalogService } from './service/service-catalog.service';
import {
	faAngleDown,
	faAngleRight,
	faAngleUp,
	faBolt,
	faBook,
	faBox,
	faCalendar,
	faCartShopping,
	faCat,
	faChain,
	faCloud,
	faComputer,
	faDesktop,
	faDice,
	faDownload,
	faFlag,
	faGlobe,
	faInstitution,
	faKeyboard,
	faMoneyBill,
	faPen,
	faPencil,
	faPerson,
	faPhone,
	faPlane,
	faQuestion,
	faQuestionCircle,
	faScroll,
	faSign,
	faSignature,
	faSigning,
	faTrash,
	faUnlock,
	faUser,
	faWheelchair,
	faWifi,
} from '@fortawesome/free-solid-svg-icons';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { forkJoin } from 'rxjs';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

export interface categoryFormInterface {
	id: number;
	portuguese: string;
	english: string;
	spanish: string;
	slovak: string;
	chinese: string;
	italian: string;
	icon: string;
	externUrl: string;
	mobile: boolean;
}

export interface questionFormInterface {
	id: number;
	portuguese: string;
	english: string;
	spanish: string;
	slovak: string;
	chinese: string;
	italian: string;

	type_predecessor: string;
	id_predecessor: number;

	informative: {
		portuguese: string;
		english: string;
		spanish: string;
		slovak: string;
		chinese: string;
		italian: string;
	};
	cod: string;
	answer: answerFormInterface[];
}

export interface answerFormInterface {
	id: number;
	id_question: number;
	portuguese: string;
	english: string;
	spanish: string;
	slovak: string;
	chinese: string;
	italian: string;
	icon: string;

	goTo: string;
	externUrl: string;
	template: number;
	kb: number;
	next_question: number;
}

@Component({
	selector: 'register-form-service-catalog',
	templateUrl: './service-catalog.component.html',
	styleUrls: ['./service-catalog.component.scss'],
})
export class ServiceCatalogComponent implements OnInit {
	icons = {
		faTrash: faTrash,
		faAngleUp: faAngleUp,
		faAngleDown: faAngleDown,
		faAngleRight: faAngleRight,
		faQuestionCircle: faQuestionCircle,
	};

	availableIcons = {
		faCat: { label: 'lbl_geral_gato', icon: faCat },
		faUser: { label: 'lbl_geral_pessoa', icon: faUser },
		faDesktop: { label: 'Desktop', icon: faDesktop },
		faUnlock: { label: 'lbl_geral_desbloquear', icon: faUnlock },
		faGlobe: { label: 'lbl_geral_globo', icon: faGlobe },
		faPhone: { label: 'lbl_geral_telefone', icon: faPhone },
		faScroll: { label: 'lbl_geral_pergaminho', icon: faScroll },
		faBolt: { label: 'lbl_geral_raio', icon: faBolt },
		faBook: { label: 'lbl_geral_livro', icon: faBook },
		faBox: { label: 'lbl_geral_caixa', icon: faBox },
		faCartShopping: { label: 'lbl_geral_carrinho_compras', icon: faCartShopping },
		faCalendar: { label: 'lbl_geral_calendario', icon: faCalendar },
		faChain: { label: 'lbl_geral_corrente', icon: faChain },
		faComputer: { label: 'lbl_geral_computador', icon: faComputer },
		faCloud: { label: 'lbl_geral_nuvem', icon: faCloud },
		faDice: { label: 'lbl_geral_dado', icon: faDice },
		faDownload: { label: 'Download', icon: faDownload },
		faFlag: { label: 'lbl_geral_bandeira', icon: faFlag },
		faInstitution: { label: 'lbl_geral_instituicao', icon: faInstitution },
		faKeyboard: { label: 'lbl_asset_teclado', icon: faKeyboard },
		faMoneyBill: { label: 'lbl_geral_dinheiro', icon: faMoneyBill },
		faPen: { label: 'lbl_geral_caneta', icon: faPen },
		faPencil: { label: 'lbl_geral_lapis', icon: faPencil },
		faPlane: { label: 'lbl_geral_aviao', icon: faPlane },
		faQuestion: { label: 'lbl_geral_pergunta', icon: faQuestion },
		faSignature: { label: 'lbl_geral_assinatura', icon: faSignature },
		faWheelchair: { label: 'lbl__geral_cadeira_rodas', icon: faWheelchair },
		faWifi: { label: 'Wi-fi', icon: faWifi },
	};

	labels: LabelsInterface = {
		lbl_edocs_carregando: '',
		lbl_clique_confirmar_acao: '',
		lbl_geral_sim: '',
		lbl_geral_nao: '',
		lbl_successful_updated: '',
		lbl_asset_category: '',
		lbl_categoria_primeira_etapa_autoatendimento: '',
		lbl_geral_questions: '',
		lbl_nome_nova_categoria: '',
		lbl_nao_preencher_campo_idioma_adicionar: '',
		lbl_geral_portugues: '',
		lbl_geral_ingles: '',
		lbl_geral_espanhol: '',
		lbl_geral_eslovaco: '',
		lbl_geral_chines: '',
		lbl_geral_italiano: '',
		lbl_link_externo: '',
		lbl_categoria_link_externo_sem_perguntas: '',
		lbl_visivel_no_mobile: '',
		lbl_geral_icone: '',
		lbl_geral_selecione: '',
		lbl_geral_adicionar: '',
		lbl_geral_salvar: '',
		lbl_vinculacao_perguntas_respostas: '',
		lbl_geral_nova: '',
		lbl_geral_question: '',
		lbl_geral_responses: '',
		lbl_geral_response: '',
		lbl_geral_vincular: '',
		lbl_geral_vinculos: '',
		lbl_url_externa: '',
		lbl_categorias: '',
		lbl_va_para: '',
		lbl_geral_unsaved_changes_form: '',
		lbl_questoes_sem_respostas: '',
		lbl_preencha_pelo_menos_idioma_padrao_cliente: '',
		lbl_geral_buscar: '',
		lbl_outros_idiomas: '',
		lbl_slam_de: '',
		lbl_geral_informativo: '',
		lbl_informativo_da_pergunta: '',
	};

	constructor(
		private LabelsService: LabelsService,
		private NotificationService: NotificationService,
		private ServiceCatalogService: ServiceCatalogService,
		public ProfileService: ProfileService
	) {
		this.filterQuestionCallBack = this.filterQuestionCallBack.bind(this);
	}

	isLoadingLabels = true;
	isLoadingCustomerData = true;
	isLoadingCategory = true;
	isLoadingQuestion = true;
	isLoadingTemplate = true;
	isLoadingKb = true;
	isUpdatingCategory = false;
	isUpdatingQuestion = false;

	selectedTab = 'category';
	// selectedQuestion = undefined;
	selectedQuestionIndex = undefined;

	availableLanguages = {
		portuguese: 'lbl_geral_portugues',
		english: 'lbl_geral_ingles',
		spanish: 'lbl_geral_espanhol',
		slovak: 'lbl_geral_eslovaco',
		chinese: 'lbl_geral_chines',
		italian: 'lbl_geral_italiano',
	};

	defaultCustomerLanguage = '';
	availableTemplate: { id: string; name: string }[] = [];
	availableKb: { id: string; name: string }[] = [];

	unsavedCategoryChanges = false;
	newCategory: categoryFormInterface = {
		id: undefined,
		portuguese: '',
		english: '',
		spanish: '',
		slovak: '',
		chinese: '',
		italian: '',
		icon: '',
		externUrl: '',
		mobile: true,
	};
	catalogCategory: categoryFormInterface[] = [];
	catalogCategoryMemory: categoryFormInterface[] = [];

	unsavedQuestionChanges = false;
	newQuestion: questionFormInterface = {
		id: undefined,
		portuguese: '',
		english: '',
		spanish: '',
		slovak: '',
		chinese: '',
		italian: '',
		answer: [],
		informative: {
			portuguese: '',
			english: '',
			spanish: '',
			slovak: '',
			chinese: '',
			italian: '',
		},
		type_predecessor: '',
		id_predecessor: undefined,
		cod: '',
	};
	newAnswer: answerFormInterface = {
		id: undefined,
		portuguese: '',
		english: '',
		spanish: '',
		slovak: '',
		chinese: '',
		italian: '',
		icon: '',
		goTo: '',
		id_question: undefined,
		next_question: undefined,
		template: undefined,
		kb: undefined,
		externUrl: '',
	};

	textFilterCatalogQuestion = '';
	catalogQuestion: questionFormInterface[] = [];
	catalogQuestionMemory: questionFormInterface[] = [];

	linkedQuestions: number[] = [];

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.ServiceCatalogService.getCustomerInfo(this.ProfileService.userData().idCustomer).subscribe((customerData) => {
			this.defaultCustomerLanguage = customerData.language.toLowerCase();
			this.isLoadingCustomerData = false;
		});

		this.ServiceCatalogService.getCategory().subscribe((catalogCategory) => {
			this.catalogCategory = [...catalogCategory];
			this.catalogCategoryMemory = [...catalogCategory];
			this.isLoadingCategory = false;
		});

		this.ServiceCatalogService.getQuestion().subscribe((catalogQuestion) => {
			this.catalogQuestion = [...catalogQuestion];
			this.catalogQuestionMemory = [...catalogQuestion];
			this.isLoadingQuestion = false;
			for (const question of this.catalogQuestion) {
				if (question.id_predecessor != undefined) this.linkedQuestions.push(question.id);
			}
		});

		this.ServiceCatalogService.getAvailableTemplates().subscribe((templates) => {
			this.availableTemplate = templates;
			this.isLoadingTemplate = false;
		});

		this.ServiceCatalogService.getAvailableKbs().subscribe((kbs) => {
			this.availableKb = kbs;
			this.isLoadingKb = false;
		});
	}

	addCategory(): void {
		if (!this.newCategory[this.defaultCustomerLanguage]) {
			this.NotificationService.setNotificationMessage(
				`${this.labels.lbl_preencha_pelo_menos_idioma_padrao_cliente} (${this.labels[this.availableLanguages[this.defaultCustomerLanguage]]})`
			);
			return;
		}

		const newCategory: categoryFormInterface = {
			id: undefined,
			portuguese:
				this.newCategory.portuguese.trim() == '' ? this.newCategory[this.defaultCustomerLanguage] : this.newCategory.portuguese,
			english: this.newCategory.english.trim() == '' ? this.newCategory[this.defaultCustomerLanguage] : this.newCategory.english,
			spanish: this.newCategory.spanish.trim() == '' ? this.newCategory[this.defaultCustomerLanguage] : this.newCategory.spanish,
			slovak: this.newCategory.slovak.trim() == '' ? this.newCategory[this.defaultCustomerLanguage] : this.newCategory.slovak,
			chinese: this.newCategory.chinese.trim() == '' ? this.newCategory[this.defaultCustomerLanguage] : this.newCategory.chinese,
			italian: this.newCategory.italian.trim() == '' ? this.newCategory[this.defaultCustomerLanguage] : this.newCategory.italian,
			icon: this.newCategory.icon,
			externUrl: this.newCategory.externUrl,
			mobile: this.newCategory.mobile,
		};

		this.catalogCategory.push({ ...newCategory });
		this.unsavedCategoryChanges = true;
		this.cleanCategoryForm();
	}

	cleanCategoryForm(): void {
		this.newCategory = {
			id: undefined,
			portuguese: '',
			english: '',
			spanish: '',
			slovak: '',
			chinese: '',
			italian: '',
			icon: '',
			externUrl: '',
			mobile: true,
		};
	}

	deleteCategoryItem(index: number): void {
		this.catalogCategory.splice(index, 1);
		this.unsavedCategoryChanges = true;
	}

	saveCategory(): void {
		if (this.isUpdatingCategory) return;
		this.isUpdatingCategory = true;

		const toUpdate = [];
		const toCreate = [];
		const existingCategoriesId = [];

		for (const category of this.catalogCategoryMemory) {
			if (category.id != undefined) existingCategoriesId.push(category.id);
		}
		for (const category of this.catalogCategory) {
			if (category.id === undefined) toCreate.push(category);
			else if (existingCategoriesId.includes(category.id)) {
				toUpdate.push(category);
				existingCategoriesId.splice(existingCategoriesId.indexOf(category.id), 1);
			}
		}

		forkJoin([
			this.ServiceCatalogService.postCategory(toCreate),
			this.ServiceCatalogService.putCategory(toUpdate),
			this.ServiceCatalogService.deleteCategory(existingCategoriesId), //Remaining ids are going to be deleted
		]).subscribe(
			(forkRes) => {
				for (const [index, category] of toCreate.entries()) {
					category.id = forkRes[0][index];
				}

				this.catalogCategoryMemory = JSON.parse(JSON.stringify(this.catalogCategory));
				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.isUpdatingCategory = false;
				this.unsavedCategoryChanges = false;
			},
			(errorRes) => {
				this.isUpdatingCategory = false;
			}
		);
	}

	confirmButton(elementReference: HTMLElement): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_clique_confirmar_acao);
		elementReference.classList.add('confirmClick');
		setTimeout(() => {
			elementReference.classList.remove('confirmClick');
		}, 5000);
	}

	addQuestion(): void {
		if (!this.newQuestion[this.defaultCustomerLanguage]) {
			this.NotificationService.setNotificationMessage(
				`${this.labels.lbl_preencha_pelo_menos_idioma_padrao_cliente} (${this.labels[this.availableLanguages[this.defaultCustomerLanguage]]})`
			);
			return;
		}

		// if(this.newQuestion.answers.length == 0) {
		//   this.NotificationService.setNotificationMessage(`_Adicione pelo menos uma resposta para essa pergunta`);
		//   return;
		// }

		const newQuestion: questionFormInterface = {
			id: undefined,
			portuguese:
				this.newQuestion.portuguese.trim() == '' ? this.newQuestion[this.defaultCustomerLanguage] : this.newQuestion.portuguese,
			english: this.newQuestion.english.trim() == '' ? this.newQuestion[this.defaultCustomerLanguage] : this.newQuestion.english,
			spanish: this.newQuestion.spanish.trim() == '' ? this.newQuestion[this.defaultCustomerLanguage] : this.newQuestion.spanish,
			slovak: this.newQuestion.slovak.trim() == '' ? this.newQuestion[this.defaultCustomerLanguage] : this.newQuestion.slovak,
			chinese: this.newQuestion.chinese.trim() == '' ? this.newQuestion[this.defaultCustomerLanguage] : this.newQuestion.chinese,
			italian: this.newQuestion.italian.trim() == '' ? this.newQuestion[this.defaultCustomerLanguage] : this.newQuestion.italian,
			answer: this.newQuestion.answer,
			informative: {
				portuguese:
					this.newQuestion.informative.portuguese.trim() == ''
						? this.newQuestion.informative[this.defaultCustomerLanguage]
						: this.newQuestion.informative.portuguese,
				english:
					this.newQuestion.informative.english.trim() == ''
						? this.newQuestion.informative[this.defaultCustomerLanguage]
						: this.newQuestion.informative.english,
				spanish:
					this.newQuestion.informative.spanish.trim() == ''
						? this.newQuestion.informative[this.defaultCustomerLanguage]
						: this.newQuestion.informative.spanish,
				slovak:
					this.newQuestion.informative.slovak.trim() == ''
						? this.newQuestion.informative[this.defaultCustomerLanguage]
						: this.newQuestion.informative.slovak,
				chinese:
					this.newQuestion.informative.chinese.trim() == ''
						? this.newQuestion.informative[this.defaultCustomerLanguage]
						: this.newQuestion.informative.chinese,
				italian:
					this.newQuestion.informative.italian.trim() == ''
						? this.newQuestion.informative[this.defaultCustomerLanguage]
						: this.newQuestion.informative.italian,
			},
			type_predecessor: this.newQuestion.type_predecessor,
			id_predecessor: this.newQuestion.id_predecessor,
			cod: this.newQuestion.cod,
		};

		this.catalogQuestion.push({ ...newQuestion });
		this.unsavedQuestionChanges = true;
		this.cleanQuestionForm();
		this.cleanAnswerForm();

		//Timeout é necessário para a função acabar e o angular rodar a atualização do html antes da
		//busca pelo dom acontecer.
		setTimeout(() => {
			const questionCardHeaderCollection = document.querySelectorAll('.question-card-header');
			const lastQuestionCardHeader = questionCardHeaderCollection[questionCardHeaderCollection.length - 1];
			lastQuestionCardHeader?.classList.add('open');
			lastQuestionCardHeader?.scrollIntoView({ behavior: 'smooth' });
		}, 250);
	}

	cleanQuestionForm(): void {
		this.newQuestion = {
			id: undefined,
			portuguese: '',
			english: '',
			spanish: '',
			slovak: '',
			chinese: '',
			italian: '',
			answer: [],
			informative: {
				portuguese: '',
				english: '',
				spanish: '',
				slovak: '',
				chinese: '',
				italian: '',
			},
			type_predecessor: '',
			id_predecessor: undefined,
			cod: '',
		};
	}

	deleteQuestionItem(index: number): void {
		this.catalogQuestion.splice(index, 1);
		this.unsavedQuestionChanges = true;
	}

	addAnswer(questionIndex: number): void {
		if (!this.newAnswer[this.defaultCustomerLanguage]) {
			this.NotificationService.setNotificationMessage(
				`${this.labels.lbl_preencha_pelo_menos_idioma_padrao_cliente} (${this.labels[this.availableLanguages[this.defaultCustomerLanguage]]})`
			);
			return;
		}

		const newAnswer: answerFormInterface = {
			id: undefined,
			portuguese: this.newAnswer.portuguese.trim() == '' ? this.newAnswer[this.defaultCustomerLanguage] : this.newAnswer.portuguese,
			english: this.newAnswer.english.trim() == '' ? this.newAnswer[this.defaultCustomerLanguage] : this.newAnswer.english,
			spanish: this.newAnswer.spanish.trim() == '' ? this.newAnswer[this.defaultCustomerLanguage] : this.newAnswer.spanish,
			slovak: this.newAnswer.slovak.trim() == '' ? this.newAnswer[this.defaultCustomerLanguage] : this.newAnswer.slovak,
			chinese: this.newAnswer.chinese.trim() == '' ? this.newAnswer[this.defaultCustomerLanguage] : this.newAnswer.chinese,
			italian: this.newAnswer.italian.trim() == '' ? this.newAnswer[this.defaultCustomerLanguage] : this.newAnswer.italian,
			icon: this.newAnswer.icon,
			goTo: '',
			id_question: this.newAnswer.id_question,
			externUrl: this.newAnswer.externUrl,
			next_question: this.newAnswer.next_question,
			kb: this.newAnswer.kb,
			template: this.newAnswer.template,
		};

		this.catalogQuestion[questionIndex].answer.push({ ...newAnswer });
		this.unsavedQuestionChanges = true;
		this.cleanAnswerForm();
	}

	cleanAnswerForm(): void {
		this.newAnswer = {
			id: undefined,
			portuguese: '',
			english: '',
			spanish: '',
			slovak: '',
			chinese: '',
			italian: '',
			icon: '',
			id_question: undefined,
			goTo: '',
			next_question: undefined,
			template: undefined,
			kb: undefined,
			externUrl: '',
		};
	}

	deleteAnswerItem(questionIndex: number, answerIndex: number): void {
		this.catalogQuestion[questionIndex].answer.splice(answerIndex, 1);
		this.unsavedQuestionChanges = true;
	}

	//Answer crud responsibility is in question crud
	saveQuestion(): void {
		if (this.isUpdatingQuestion) return;

		for (let index = 0; index < this.catalogQuestion.length; index++) {
			const question = this.catalogQuestion[index];
			if (question.answer.length === 0) {
				this.NotificationService.setNotificationMessage(this.labels.lbl_questoes_sem_respostas);
				return;
			}
		}

		this.isUpdatingQuestion = true;

		const toUpdate = [];
		const toCreate = [];
		const existingQuestionId = [];

		for (const question of this.catalogQuestionMemory) {
			if (question.id != undefined) existingQuestionId.push(question.id);
		}
		for (const question of this.catalogQuestion) {
			if (question.id === undefined) toCreate.push(question);
			else if (existingQuestionId.includes(question.id)) {
				toUpdate.push(question);
				existingQuestionId.splice(existingQuestionId.indexOf(question.id), 1);
			}
		}

		forkJoin([
			this.ServiceCatalogService.postQuestion(toCreate),
			this.ServiceCatalogService.putQuestion(toUpdate),
			this.ServiceCatalogService.deleteQuestion(existingQuestionId), //Remaining ids are going to be deleted
		]).subscribe(
			(forkRes) => {
				if (toCreate.length > 0) {
					this.isLoadingQuestion = true;
					this.ServiceCatalogService.getQuestion().subscribe((catalogQuestion) => {
						this.catalogQuestion = [...catalogQuestion];
						this.catalogQuestionMemory = [...catalogQuestion];
						this.isLoadingQuestion = false;
						for (const question of this.catalogQuestion) {
							if (question.id_predecessor != undefined) this.linkedQuestions.push(question.id);
						}
					});
				}

				this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				this.isUpdatingQuestion = false;
				this.unsavedQuestionChanges = false;
			},
			(errorRes) => {
				this.isUpdatingQuestion = false;
			}
		);
	}

	//O processo aqui é reverso, a categoria é salva na pergunta, mas
	//para facilitar a visualização do usuário, a gente mostra como se estivesse salvando a pergunta na categoria
	linkCategoryQuestion(idCategory: number, idQuestion?: number): void {
		if (idQuestion == -1) {
			//Se a questão é -1, a questão foi desvinculada, dado que a construção tá sendo montada no reverso
			//procuramos a categoria para desvincular a questão
			for (let index = 0; index < this.catalogQuestion.length; index++) {
				const question = this.catalogQuestion[index];
				if (question.id_predecessor && question.id_predecessor.toString() == idCategory.toString()) {
					question.id_predecessor = undefined;
					question.type_predecessor = '';
					this.linkedQuestions.splice(this.linkedQuestions.indexOf(Number.parseInt(question.id.toString())), 1);
				}
			}
		} else {
			//Antes de vincular uma pergunta numa categoria,
			//checa se essa categoria já estava vinculada para desvincular
			for (let index = 0; index < this.catalogQuestion.length; index++) {
				const question = this.catalogQuestion[index];
				if (question.id_predecessor && question.id_predecessor.toString() == idCategory.toString()) {
					this.linkedQuestions.splice(this.linkedQuestions.indexOf(Number.parseInt(question.id.toString())), 1);
				}
			}

			//Faz o vínculo propriamente
			for (let index = 0; index < this.catalogQuestion.length; index++) {
				const question = this.catalogQuestion[index];
				if (question.id.toString() === idQuestion.toString()) {
					question.type_predecessor = 'category';
					question.id_predecessor = idCategory;
					if (!this.linkedQuestions.includes(Number.parseInt(idQuestion.toString())))
						this.linkedQuestions.push(Number.parseInt(idQuestion.toString()));
				}
			}
		}
	}

	cleanAnswerGoTo(indexQuestion: number, indexAnswer: number): void {
		this.catalogQuestion[indexQuestion].answer[indexAnswer].next_question = undefined;
		this.catalogQuestion[indexQuestion].answer[indexAnswer].externUrl = '';
		this.catalogQuestion[indexQuestion].answer[indexAnswer].template = undefined;
		this.catalogQuestion[indexQuestion].answer[indexAnswer].kb = undefined;
	}

	linkAnswerQuestion(indexQuestion: number, indexAnswer: number, idQuestion: number): void {
		const answer = this.catalogQuestion[indexQuestion].answer[indexAnswer];
		if (answer.next_question) {
			this.linkedQuestions.splice(this.linkedQuestions.indexOf(Number.parseInt(answer.next_question.toString())), 1);
		}
		if (idQuestion) {
			answer.next_question = idQuestion;
			this.linkedQuestions.push(Number.parseInt(idQuestion.toString()));
		} else {
			answer.next_question = undefined;
		}
	}

	notifyUnsavedChanges(): void {
		this.NotificationService.setNotificationMessage(this.labels.lbl_geral_unsaved_changes_form);
	}

	resetCategory(): void {
		this.catalogCategory = JSON.parse(JSON.stringify(this.catalogCategoryMemory));
	}

	resetQuestion(): void {
		this.catalogQuestion = JSON.parse(JSON.stringify(this.catalogQuestionMemory));
	}

	filterQuestionCallBack(question: questionFormInterface) {
		if (this.textFilterCatalogQuestion.trim() == '') return true;
		return question[this.defaultCustomerLanguage].toLowerCase().includes(this.textFilterCatalogQuestion.toLocaleLowerCase());
	}
}
